import { createReducer } from '@reduxjs/toolkit'
import { Route } from 'react-router'
import React from 'react'
import SkudView from './skud_view'

export const reducer = createReducer({}, () => {})

export const routes = (
  <Route path="skud" element={<SkudView />} />
)
